import { inject, injectable } from 'inversify';
import {
  InjectionSymbols as LoggerInjectionSymbols,
  type Logger,
} from '@hitiq/logger';
import { AmplifyDataStore } from '../../dataStorePersistence/AmplifyDataStore';
import { ModelTypes } from '../../dataStorePersistence/DataStoreModel';
import { Assessment, AssessmentBackend } from './assessments.interfaces';
import { defaultSelectors, defaultDispatchers } from './assessments.slice';
import { ReduxRepository } from '../reduxRepository';
import { AssessmentTranslator } from './assessment.translator';
import { updateAssessmentThunk } from './assessmentUpdate.thunk';
import { deleteAssessmentThunk } from './assessmentDelete.thunk';
import { createAssessmentThunk } from './assessmentCreate.thunk';
import { loadAssessmentsThunk } from './assessmentLoad.thunk';

@injectable()
export class AssessmentRepository extends ReduxRepository<
  Assessment,
  AssessmentBackend
> {
  constructor(
    @inject(LoggerInjectionSymbols.LOGGER)
    protected readonly loggingService: Logger,
    protected readonly datastore: AmplifyDataStore<AssessmentBackend>,
  ) {
    super(
      ModelTypes.Assessment,
      new AssessmentTranslator(),
      datastore,
      loggingService,
      defaultSelectors,
      defaultDispatchers,
      createAssessmentThunk,
      updateAssessmentThunk,
      deleteAssessmentThunk,
      loadAssessmentsThunk,
    );
  }
}
